<template>
	<div>
		<slot>Set content as inline template.</slot>
	</div>
</template>

<script>
	export default {
		props: ['id'],
		data() {
			return {
				data: null,
				loading: false
			}
		},
		mounted() {
			let url = this.route('api.collection');
			if (this.id != '') {
				url = this.route('api.collection', this.id);
			} 
			this.loading = true;
			axios.get(url).then(response => {
				this.loading = false;
				if (this.id != '') {
					this.$root.$emit('add-title', response.data.title);
					this.data = response.data;
				} else {
					this.data = response.data;
				}
			});
		},
		methods: {
			open(index) {
				let data = this.id != '' ? this.data.subitems[index] : this.data[index];
				if (data.subitems) {
						window.location = this.route('collection', data.credit);
				} else {
					if (this.id != '') {
						window.open(this.route('content', this.id + '~' + data.index));
					} else {
						window.open(this.route('content', data.credit));
					}
				}
			},
			coverPath(item) {
				return item.interactiveCover ? item.interactiveCover : item.cover
			}
		},
		computed: {
			hasLicences() {
				if (this.data == null || this.data.length == 0) return false;
				return true;
			}
		}
	}

</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Collection.vue